import content from "./archContent.json";

export type ArchBlock =
  | {
      type: "image";
      src: string;
      alt?: string;
      width?: number;
      height?: number;
    }
  | { type: "text"; body: string }
  | { type: "stats"; items: { label: string; value: string }[] };

// Curated focus-panel content per arch project, keyed by focus id
// ("arch:<projectName>"). Edit with the local UI: bun scripts/arch-content-editor.mjs
export const ARCH_CONTENT = content as Record<string, ArchBlock[]>;
